"use client";

import PolliaFaceVeryGood from "@public/svgs/face/very-good.svg";
import { cn } from "@repo/ui/lib";
import { type VariantProps, cva } from "class-variance-authority";
import Image from "next/image";
import { useState } from "react";

const avataVariants = cva("relative shrink-0 overflow-hidden rounded-full", {
  variants: {
    size: {
      small: "size-6",
      large: "size-[96px]",
    },
    hasImage: {
      true: "border-default",
      false: "bg-zinc-200",
    },
  },
  compoundVariants: [
    { size: "small", hasImage: true, class: "border-[0.3px]" },
    { size: "large", hasImage: true, class: "border" },
  ],
  defaultVariants: {
    size: "small",
    hasImage: false,
  },
});

const iconVariants = cva("text-zinc-500", {
  variants: {
    size: {
      small: "size-[18px]",
      large: "size-[68px]",
    },
  },
});

interface AvataProps {
  imageUrl?: string | null;
  size: NonNullable<VariantProps<typeof avataVariants>["size"]>;
  className?: string;
}

export function Avata({ imageUrl, size, className }: AvataProps) {
  const [imageError, setImageError] = useState(false);
  const hasImage = !!imageUrl && !imageError;

  return (
    <div className={cn(avataVariants({ size, hasImage }), className)}>
      {hasImage ? (
        <Image
          src={imageUrl}
          alt="프로필"
          fill
          className="object-cover"
          onError={() => setImageError(true)}
        />
      ) : (
        <div className="absolute inset-0 flex items-center justify-center">
          <PolliaFaceVeryGood className={iconVariants({ size })} />
        </div>
      )}
    </div>
  );
}
